import * as React from 'react';

import { StatsigProvider } from '@coursera-web/statsig';
import { compose } from 'recompose';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import withFetchLazyImages from 'bundles/page/components/shared/utils/withFetchLazyImages';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!bundles/unified-description-page-common/__styles__/index';

type Props = {
  children?: JSX.Element;
};

const ConsumerPageWrapper = ({ children }: Props) => {
  return (
    <StatsigProvider>
      <DefaultHeader isPositionStatic />
      <UniversalPageFeatures />
      {children}
      <PageFooter isStickyBarPresent />
    </StatsigProvider>
  );
};

export default compose<Props, {}>(withMarketingConsent, withFetchLazyImages)(ConsumerPageWrapper);
